import React from 'react';
import { Brain, Moon, Heart, ShieldCheck, CheckCircle2 } from 'lucide-react';
import { FormEmbed } from '../components/FormEmbed';
export function ResourcesV2() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#eef4fb] font-sans text-[#1e3a5f]" data-id="element-71">
      <main data-id="element-72">
        {/* HERO — split layout: Asha photo left, text right */}
        <section className="relative overflow-hidden min-h-[55vh] flex items-stretch" data-id="element-73">
          {/* Left: Asha photo — full bleed */}
          <div className="hidden md:block md:w-1/2 relative" data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/jXrAyLm7PSjjzrEshZuigQ/AshaMiniShoot-6_(1).jpg" alt="Asha, registered hypnotherapist, by the lake" className="absolute inset-0 w-full h-full object-cover" style={{
            objectPosition: 'center 25%'
          }} data-id="element-75" />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#1e3a5f]/20" data-id="element-76" />
          </div>

          {/* Right: text content on navy bg */}
          <div className="w-full md:w-1/2 bg-[#1e3a5f] flex items-center px-8 md:px-12 py-14" data-id="element-77">
            {/* Mobile: show photo as background */}
            <div className="absolute inset-0 md:hidden" data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/jXrAyLm7PSjjzrEshZuigQ/AshaMiniShoot-6_(1).jpg" alt="Asha, registered hypnotherapist" className="w-full h-full object-cover" style={{
              objectPosition: 'center 25%'
            }} data-id="element-79" />
              <div className="absolute inset-0 bg-[#1e3a5f]/75" data-id="element-80" />
            </div>

            <div className="relative z-10 max-w-md space-y-5" data-id="element-81">
              <h1 className="text-3xl md:text-4xl font-bold text-white leading-snug" data-id="element-82">
                Struggling with anxiety, sleep or menopause symptoms?
              </h1>
              <p className="text-blue-100 text-base leading-relaxed" data-id="element-83">
                Download a free professionally guided hypnotherapy session
                today.
              </p>
              <a href="#forms" className="inline-block bg-white text-[#1e3a5f] px-8 py-3 rounded-lg font-bold text-sm shadow-lg hover:bg-blue-50 transition-colors" data-id="element-84">
                Get instant access
              </a>
            </div>
          </div>
        </section>

        {/* QUICK NAV */}
        <section className="bg-white border-b border-gray-100 py-4 px-4 sticky top-0 z-40 shadow-sm" data-id="element-85">
          <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm" data-id="element-86">
            <span className="text-gray-400 font-medium text-xs uppercase tracking-wider" data-id="element-87">
              Jump to:
            </span>
            <button onClick={() => scrollTo('form-menopause')} className="text-[#1e3a5f] font-semibold hover:text-[#4a7ab5] transition-colors" data-id="element-88">
              Menopause
            </button>
            <span className="text-gray-300 hidden sm:inline" data-id="element-89">|</span>
            <button onClick={() => scrollTo('form-anxiety')} className="text-[#1e3a5f] font-semibold hover:text-[#4a7ab5] transition-colors" data-id="element-90">
              Anxiety to confidence
            </button>
            <span className="text-gray-300 hidden sm:inline" data-id="element-91">|</span>
            <button onClick={() => scrollTo('form-sleep')} className="text-[#1e3a5f] font-semibold hover:text-[#4a7ab5] transition-colors" data-id="element-92">
              Restful sleep
            </button>
          </div>
        </section>

        {/* BENEFIT STRIP */}
        <section className="bg-[#eef4fb] py-8 px-4" data-id="element-93">
          <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-6 text-center" data-id="element-94">
            <div className="flex flex-col items-center gap-2" data-id="element-95">
              <Brain className="w-6 h-6 text-[#4a7ab5]" strokeWidth={1.5} data-id="element-96" />
              <span className="text-sm font-semibold text-[#1e3a5f]" data-id="element-97">
                Calmer mind
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-98">
              <Moon className="w-6 h-6 text-[#4a7ab5]" strokeWidth={1.5} data-id="element-99" />
              <span className="text-sm font-semibold text-[#1e3a5f]" data-id="element-100">
                Restful sleep
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-101">
              <Heart className="w-6 h-6 text-[#4a7ab5]" strokeWidth={1.5} data-id="element-102" />
              <span className="text-sm font-semibold text-[#1e3a5f]" data-id="element-103">
                Emotional balance
              </span>
            </div>
          </div>
        </section>

        {/* VIDEO — landscape, meet your hypnotherapist */}
        <section className="py-14 px-4 bg-white" data-id="element-104">
          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10 items-center" data-id="element-105">
            <div className="space-y-5 order-1 md:order-2" data-id="element-106">
              <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5f]" data-id="element-107">
                Meet your hypnotherapist
              </h2>
              <p className="text-gray-500 leading-relaxed text-sm" data-id="element-108">
                Hi, I'm Asha. I'm a multi-award-winning registered
                hypnotherapist based in Solihull, working with clients across
                Birmingham and online. I combine evidence-based neuroscience
                with compassionate care to help you make lasting change. These
                recordings are a first step.
              </p>
              <div className="flex items-center gap-2 text-sm font-semibold text-[#1e3a5f]" data-id="element-109">
                <ShieldCheck className="w-4 h-4 text-[#4a7ab5]" strokeWidth={1.5} data-id="element-110" />
                <span data-id="element-111">NCH · AfSFH · CNHC registered</span>
              </div>
            </div>
            {/* Landscape video */}
            <div className="order-2 md:order-1" data-id="element-112">
              <div className="relative w-full aspect-video rounded-2xl overflow-hidden border-2 border-white" style={{
              boxShadow: '0 8px 40px rgba(30,58,95,0.16)'
            }} data-id="element-113">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/HmUfhvAQlWU" title="Meet Asha, your hypnotherapist" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-114" />
              </div>
            </div>
          </div>
        </section>

        {/* FORMS — stacked vertically */}
        <section id="forms" className="py-16 px-4 bg-[#eef4fb]" data-id="element-115">
          <div className="max-w-3xl mx-auto" data-id="element-116">
            <div className="text-center mb-10" data-id="element-117">
              <h2 className="text-2xl font-bold text-[#1e3a5f]" data-id="element-118">
                Choose your free session
              </h2>
              <p className="text-gray-500 mt-2 text-sm" data-id="element-119">
                Enter your details to receive your audio download link.
              </p>
            </div>

            <div className="space-y-8" data-id="element-120">
              {/* Form 1 — Menopause */}
              <div id="form-menopause" className="bg-white rounded-2xl overflow-hidden" style={{
              boxShadow: '0 4px 20px rgba(0,0,0,0.07)'
            }} data-id="element-121">
                <div className="bg-[#1e3a5f] px-6 py-5 text-white text-center" data-id="element-122">
                  <h3 className="text-lg font-bold" data-id="element-123">Menopause support</h3>
                  <p className="text-blue-200 text-sm mt-1" data-id="element-124">
                    Natural relief for hot flushes and hormonal balance.
                  </p>
                </div>
                <div className="p-5" data-id="element-125">
                  <FormEmbed formId="poXAdqeTuzz4bBBs2MV9" formName="Menopause MP3" iframeId="inline-poXAdqeTuzz4bBBs2MV9-v2" height={450} data-id="element-126" />
                  <p className="text-xs text-center text-[#1e3a5f]/60 mt-3 flex items-center justify-center gap-1" data-id="element-127">
                    <CheckCircle2 className="w-3 h-3 flex-shrink-0" data-id="element-128" />
                    Your details are kept strictly confidential.
                  </p>
                </div>
              </div>

              {/* Form 2 — Anxiety */}
              <div id="form-anxiety" className="bg-white rounded-2xl overflow-hidden" style={{
              boxShadow: '0 4px 20px rgba(0,0,0,0.07)'
            }} data-id="element-129">
                <div className="bg-[#4a7ab5] px-6 py-5 text-white text-center" data-id="element-130">
                  <h3 className="text-lg font-bold" data-id="element-131">Anxiety to confidence</h3>
                  <p className="text-blue-100 text-sm mt-1" data-id="element-132">
                    Replace worry with calm, capable confidence.
                  </p>
                </div>
                <div className="p-5" data-id="element-133">
                  <FormEmbed formId="poXAdqeTuzz4bBBs2MV9" formName="Anxiety MP3" iframeId="inline-anxiety-poXAdqeTuzz4bBBs2MV9-v2" height={450} data-id="element-134" />
                  <p className="text-xs text-center text-[#1e3a5f]/60 mt-3 flex items-center justify-center gap-1" data-id="element-135">
                    <CheckCircle2 className="w-3 h-3 flex-shrink-0" data-id="element-136" />
                    Your details are kept strictly confidential.
                  </p>
                </div>
              </div>

              {/* Form 3 — Sleep */}
              <div id="form-sleep" className="bg-white rounded-2xl overflow-hidden" style={{
              boxShadow: '0 4px 20px rgba(0,0,0,0.07)'
            }} data-id="element-137">
                <div className="bg-[#1e3a5f] px-6 py-5 text-white text-center" data-id="element-138">
                  <h3 className="text-lg font-bold" data-id="element-139">Restful sleep</h3>
                  <p className="text-blue-200 text-sm mt-1" data-id="element-140">
                    Retrain your mind for deep, restorative rest.
                  </p>
                </div>
                <div className="p-5" data-id="element-141">
                  <FormEmbed formId="LUc3SIG5R30MtnKlbZ7r" formName="Sleep MP3" iframeId="inline-LUc3SIG5R30MtnKlbZ7r-v2" height={450} data-id="element-142" />
                  <p className="text-xs text-center text-[#1e3a5f]/60 mt-3 flex items-center justify-center gap-1" data-id="element-143">
                    <CheckCircle2 className="w-3 h-3 flex-shrink-0" data-id="element-144" />
                    Your details are kept strictly confidential.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CLOSING CTA */}
        <section className="py-12 px-4 bg-white text-center" data-id="element-145">
          <div className="max-w-sm mx-auto space-y-4" data-id="element-146">
            <p className="text-gray-500 text-sm" data-id="element-147">Prefer one to one support?</p>
            <a href="https://mindability-hypnotherapy.co.uk/location/" target="_blank" rel="noopener noreferrer" className="block bg-[#1e3a5f] text-white px-8 py-3 rounded-lg font-semibold text-sm hover:bg-[#162d4a] transition-colors" data-id="element-148">
              Book your consultation
            </a>
          </div>
        </section>
      </main>
    </div>;
}